import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';

export const AutocompleteInput = styled.input`
  width: 100%;
  border: none;
  margin-left: 3px;
  ${getFont(0)};
  line-height: 36px;

  ::placeholder {
    padding-left: 2px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${({ theme }) => theme.colors.fontLL};
  }

  /* stylelint-disable */
  :-ms-input-placeholder {
    display: inline-block;
    line-height: normal;
  }
  /* stylelint-enable */

  &[disabled] {
    ::placeholder {
      color: ${({ theme }) => theme.colors.negative};
    }
  }
`;
